module.exports = __webpack_public_path__ + "img/Spirou.88e94821.svg";